import React, { FC } from 'react'
import { hot } from 'react-hot-loader/root'
import {
  Route,
  RouteProps,
  Switch,
} from 'react-router-dom'

import { URL } from './constants/url'
import LangRoute from './LangRoute'
import Main from './templates/Main'
import Single from './templates/Single'

import Login from './pages/Login'
import LoginMicrosoftCallback from './pages/login/LoginMicrosoftCallback'
import LoginGoogleCallback from './pages/login/LoginGoogleCallback'
import ResetPassword from './pages/ResetPassword'
import LoginResetPassword from './pages/login/LoginResetPassword'
import LoginMicrosoftZendeskCallback from './pages/login/LoginMicrosoftZendeskCallback'
import LoginGoogleZendeskCallback from './pages/login/LoginGoogleZendeskCallback'
import PublicClientDownload from './pages/PublicClientDownload'

interface RouteWithLayoutProps extends RouteProps {
  component: FC
  layout: FC
}

const RouteWithLayout = ({
  component: Component,
  layout: Layout,
  ...otherProps
}: RouteWithLayoutProps) => (
  <Route
    {...otherProps}
    render={() => (
      <Layout>
        <Component />
      </Layout>
    )}
  />
)

const App: FC = () => (
  <Switch>
    <RouteWithLayout exact path={URL.LOGIN.path} layout={Single} component={Login} />
    <RouteWithLayout exact path={URL.LOGIN_RESET_PASSWORD.path} layout={Single} component={LoginResetPassword} />
    <RouteWithLayout exact path={URL.RESET_PASSWORD.path} layout={Single} component={ResetPassword} />
    <RouteWithLayout exact path={URL.LOGIN_MICROSOFT_CALLBACK.path} layout={Single} component={LoginMicrosoftCallback} />
    <RouteWithLayout exact path={URL.LOGIN_GOOGLE_CALLBACK.path} layout={Single} component={LoginGoogleCallback} />
    <RouteWithLayout exact path={URL.LOGIN_MICROSOFT_ZENDESK_CALLBACK.path} layout={Single} component={LoginMicrosoftZendeskCallback} />
    <RouteWithLayout exact path={URL.LOGIN_GOOGLE_ZENDESK_CALLBACK.path} layout={Single} component={LoginGoogleZendeskCallback} />
    <RouteWithLayout exact path={URL.PUBLIC_CLIENT_DOWNLOAD.path} layout={Single} component={PublicClientDownload} />
    <RouteWithLayout path="/:language" layout={Main} component={LangRoute} />
  </Switch>
)

export default hot(App)
